<button [ngClass]="['countdown-pill', 'countdown-pill--' + size()]" [ngStyle]="pillStyles | theme">
  <app-icon
    class="stopwatch-icon"
    icon="stopwatch"
    colorCss="--pill-countdown-icon-fill"
    sizeCss="--icon-medium"
  />
  <span class="content" [ngStyle]="labelStyles | theme">
    {{ timeRemaining() }}
  </span>
</button>
